import { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import useAuth from 'src/hooks/useAuth';
import Login from 'src/content/pages/Auth/Login/Cover';
import firebase from 'src/utils/firebase';

const checkIfRoleExists = async () => {
  const idTokenResult = await firebase?.auth()?.currentUser?.getIdTokenResult();
  // const token = await firebase?.auth()?.currentUser?.getIdToken();
  // console.log('token', token);
  let claims = idTokenResult?.claims;
  if (
    claims &&
    (claims.role === 'admin' ||
      claims.role === 'vendor' ||
      claims.role === 'partner')
  ) {
    return true;
  }
  return false;
};
const Authenticated = (props) => {
  const { children } = props;
  const auth = useAuth();
  const location = useLocation();
  const [requestedLocation, setRequestedLocation] = useState(null);
  checkIfRoleExists();
  if (!auth.isAuthenticated /* || !checkIfRoleExists() */) {
    if (location.pathname !== requestedLocation) {
      setRequestedLocation(location.pathname);
    }
    return <Login />;
  }

  if (requestedLocation && location.pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return <>{children}</>;
};

Authenticated.propTypes = {
  children: PropTypes.node
};

export default Authenticated;
